export const content = {
	appFileRepository: {
		headers: {
			filterTag: 'Filter',
			capNumber: 'CAP #',
			kitNumber: 'Kit #',
			program: 'Program',
			dateReceived: 'Date Received',
			labFiles: 'Lab Baseline Files',
			vendorUploadDate: 'Date Uploaded',
			vendorUploadLink: 'Vendor Processed Files',
			mailingId: 'Mailing'
		},
		buttons: {
			downloadPrenalytics: 'DOWNLOAD ALL PREANALYTICS',
			downloadStarterFiles: 'DOWNLOAD ALL LAB FOLDERS',
			uploadVendorFiles: 'UPLOAD TO ALL LAB FOLDERS'
		},
		messages: {
			tbd: 'tbd'
		},
		miscContent: {
			tbd: 'tbd'
		}
	},
	appLogout: {
		logoutHeader: 'Log Out',
		logoutMessage: 'You are logged out.'
	},
	appSystemMaintenance: {
		maintenanceHeader: 'System Under Maintenance',
		maintenanceMessage: 'The system is currently under maintenance. Please give us some time to finish up before you try again.'
	},
	'app-unauthorized-landing': {
		unauthorizedHeader: 'Unauthorized Access',
		unauthorizedMessage: 'We are sorry, you do not have permission to access this content. <br><br> <a href="https://www.cap.org/contact-and-support/contact-us">Contact the CAP</a> with questions or if you believe you reached this message in error'
	},
	buttons: {
		tbd1: 'tbd',
		tbd2: 'tbd',
		tbd3: 'tbd',
		approveVendorFiles: 'VALIDATE & NOTIFY LAB'
	},
	messages: {
		tbd1: 'tbd',
		tbd2: 'tbd',
		tbd3: 'tbd'
	},
	miscContent: {
		tbd1: 'tbd',
		tbd2: 'tbd',
		tbd3: 'tbd'
	}
};